import { render, staticRenderFns } from "./RoundedBigCard.vue?vue&type=template&id=9828df70&scoped=true&"
import script from "./RoundedBigCard.vue?vue&type=script&lang=js&"
export * from "./RoundedBigCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9828df70",
  null
  
)

export default component.exports